export var docElement = document.documentElement;


//////////////////
// WEBPACK FOOTER
// ./node_modules/tiny-slider/src/helpers/docElement.js
// module id = 26
// module chunks = 0